import {createContext, useState, useEffect} from "react";
import {createUserDocumentFromAuth, onAuthStateChangedListener} from "../utils/firebase/firebase.utils";

export const UserContext = createContext({
    currentUser: null,
    setCurrentUser: () => null,
});

// Extracted function
const updateUserState = (user, setCurrentUser) => {
    console.log(user);
    if (user) {
        createUserDocumentFromAuth(user);
    }
    setCurrentUser(user);
}

export const UserProvider = ({children}) => {
    const [currentUser, setCurrentUser] = useState(null);
    const value = {currentUser, setCurrentUser};

    useEffect(() => {
        const unSubscribe = onAuthStateChangedListener(user => updateUserState(user, setCurrentUser));
        return unSubscribe;
    }, []);

    return <UserContext.Provider value={value}>
        {children}
    </UserContext.Provider>
}
